import React, { useState, useEffect } from "react";
import { isAdmin } from "../api/controller/userType";
import { useNavigate, useParams, Link } from "react-router-dom";
import { FaUsers, FaMapMarkerAlt, FaFilter, FaArrowLeft, FaHeart } from "react-icons/fa";
import { IndustryCardData } from "../api/controller/videoController/industry";
import IndustryDialog from "./DialogBoxes/IndustryDialog";
import { RegionsCardData } from "../api/controller/videoController/regions";
import Logo from "../assets/VRP.png"
import Loader from "../components/Loader";
// Industry Card Component
const IndustryCard = ({ industry }) => {
  const navigate = useNavigate();
  return (

    // <div className="border-[0.5px] border-[#003DA5] bg-white rounded-md shadow w-[270px] h-[300px] overflow-hidden hover:shadow-lg hover:scale-105 transition-transform mx-5 flex-shrink-0 snap-center">
    //   <img
    //     src={industry.imageURL}
    //     className="h-[150px] w-full object-cover cursor-pointer"
    //     alt={industry.name}
    //     onClick={() => navigate(`/video-platform/regions/:region/industries/:industry/videos`.replace(':region', industry.location).replace(':industry', industry.name))}
    //   />

  <Link
      to={`/video-platform/regions/:region/industries/:industry/videos`.replace(':region', industry.location).replace(':industry', industry.name)}
      className="bg-white w-full max-w-[290px] mx-auto h-[330px] rounded-md shadow border-[0.5px] border-[#003DA5] hover:shadow-lg hover:scale-105 transition-transform duration-300"
    >
      <div className="relative">
        <img
          src={industry.imageURL}
          className="h-[150px] w-full object-cover"
          alt={industry.name}
        />
      </div>
      <div className="p-4">
        <h3 className="text-lg text-[#003DA5] font-semibold font-['corporate-s'] mb-3 flex items-center gap-2">
          {industry.location ? `${industry.location.split(',')[0]} ${industry.name}` : industry.name}
        </h3>
        <div className="space-y-2 text-[14px] font-['corporate-s']">
          <div className="flex items-center gap-2 font-semibold text-[#00244D]">
            <FaUsers />
            <span>Individuals:</span>
            <span className="text-gray-500 font-normal">{industry.individuals ?? 0}</span>
          </div>
          <div className="flex items-center gap-2 font-semibold text-[#00244D]">
            <FaMapMarkerAlt />
            <span>Location:</span>
            <span className="text-gray-500 font-normal">{industry.location || "Unknown"}</span>
          </div>
          <div className="flex items-center gap-2 font-semibold text-[#00244D]">
            <FaHeart className="text-red-500" />
            <span>Favorites:</span>
            <span className="text-gray-500 font-normal">{industry.favoriteCount ?? 0}</span>
          </div>
        </div>
      </div>
    </Link>
  );
};

// Industries Page
const Industries = () => {
  const navigate = useNavigate();
  const { region } = useParams();
  const [industries, setIndustries] = useState([]);
  const [regionsData, setRegionsData] = useState([]);
  const industrySearch = "";
  const [locationFilter, setLocationFilter] = useState(region || "");
  const [industryFilter, setIndustryFilter] = useState("");
  const [showIndustryDialog, setShowIndustryDialog] = useState(false);
  const [isLoadingIndustries, setIsLoadingIndustries] = useState(false);

  const isLoggedIn = Boolean(localStorage.getItem("authToken"));
  useEffect(() => {
    if (isLoggedIn) {
      const fetchIndustries = async () => {
        try {
          setIsLoadingIndustries(true);
          const data = await IndustryCardData(region);

          const regionsData = await RegionsCardData();
          setRegionsData(regionsData);
          setIndustries(data);
        } catch (error) {
          console.error("Error fetching industries:", error);
        } finally {
          setIsLoadingIndustries(false);
        }
      };
      fetchIndustries();
    }
  }, [isLoggedIn, region]);

  const handleLocationFilter = (e) => setLocationFilter(e.target.value);
  const handleIndustryFilter = (e) => {
    setIndustryFilter(e.target.value);
  };

  const createIndustry = (newIndustry) => {
    setIndustries((prev) => [...prev, newIndustry]);
  };

  const filteredIndustries = React.useMemo(
    () =>
      industries.filter(
        (ind) =>
          ind.name?.toLowerCase().includes(industrySearch.toLowerCase()) &&
          (locationFilter ? ind.location === locationFilter : true) &&
          (industryFilter ? ind.name === industryFilter : true)
      ),
    [locationFilter, industryFilter, industries]
  );

  const uniqueLocations = [...new Set(regionsData.map((ind) => ({ _id: ind._id, location: ind.location })))];
  const uniqueIndustries = [...new Set(industries.map((ind) => ind.name))];
  const dropdownUniqueLocations = [...new Set(industries.map((city) => ({ city: city.location, cityId: city.id })))];

  if (!isLoggedIn) {
    return (
      <div className="flex flex-col justify-center items-center text-center p-6 space-y-4">
        <h2 className="text-4xl font-['corporate-s'] text-[#00244D] mb-2">
          You need to have login to access the content
        </h2>
        <p className="text-gray-600 mb-4 font-['corporate-s']">
          You need an account to access this content.
        </p>
        <div className="flex flex-col sm:flex-row gap-4">
          <button
            onClick={() => navigate("/login")}
            className="bg-[#00244D] text-[#f0f0f0] px-6 py-3 rounded-lg font-['corporate-s']"
          >
            Login / Create Account
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="font-['corporate-s']">
              <div className="relative w-full h-full">
          <img src= {Logo}
          alt="TWA logo"
          className="w-full h-full object-cover" />

        </div>
      <section className="bg-gray-100 py-6 px-4 sm:px-6 lg:px-8 min-h-screen">
        <div className="max-w-7xl mx-auto">
          <h2 className="text-2xl sm:text-3xl lg:text-4xl font-normal font-['farnham-display'] text-[#003DA5] text-center mb-4 sm:mb-6">
            {region ? `${region.split(',')[0]} Industries` : "Industries"}
          </h2>
          <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center gap-4 mb-4 sm:mb-6">
            <button
              onClick={() => navigate("/video-platform/regions")}
              className="border-2 border-[#003DA5] text-[#fff] bg-[#003DA5] px-4 sm:px-6 py-2  font-['corporate-s'] hover:bg-[#003DA5] hover:text-white transition-colors flex items-center gap-2 w-full sm:w-auto text-sm sm:text-base"
            >
              <FaArrowLeft size={14} />
              Regions
            </button>
            <div className="flex flex-col sm:flex-row sm:flex-wrap sm:justify-end gap-2 sm:gap-4">
              {/* <div className="relative w-full sm:w-64">
                <input
                  ref={industrySearchRef}
                  type="text"
                  placeholder="Search industries..."
                  className="border border-[#003DA5] bg-white rounded-lg pl-10 pr-4 py-2 text-[#003DA5] text-sm font-semibold w-full focus:outline-none focus:ring-2 focus:ring-[#003DA5]"
                  value={industrySearch}
                  onChange={handleIndustrySearch}
                />
                <FaSearch className="absolute left-3 top-1/2 transform -translate-y-1/2 text-[#003DA5] text-sm" />
              </div> */}
              {!region && (
                <>
                  <div className="relative w-full sm:w-48">
                    <select
                      value={locationFilter}
                      onChange={handleLocationFilter}
                      className="border border-[#003DA5] bg-white rounded-lg pl-10 pr-4 py-2 text-[#003DA5] text-sm font-semibold w-full appearance-none focus:outline-none focus:ring-2 focus:ring-[#003DA5]"
                    >
                      <option value="">Locations</option>
                      {uniqueLocations.map((loc) => (
                        <option key={loc} value={loc}>
                          {loc}
                        </option>
                      ))}
                    </select>
                    <FaFilter className="absolute left-3 top-1/2 transform -translate-y-1/2 text-[#003DA5] text-sm" />
                  </div>
                  <div className="relative w-full sm:w-48">
                    <select
                      value={industryFilter}
                      onChange={handleIndustryFilter}
                      className="border border-[#003DA5] bg-white rounded-lg pl-10 pr-4 py-2 text-[#003DA5] text-sm font-semibold w-full appearance-none focus:outline-none focus:ring-2 focus:ring-[#003DA5]"
                    >
                      <option value="">Industries</option>
                      {uniqueIndustries.map((ind) => (
                        <option key={ind} value={ind}>
                          {ind}
                        </option>
                      ))}
                    </select>
                    <FaFilter className="absolute left-3 top-1/2 transform -translate-y-1/2 text-[#003DA5] text-sm" />
                  </div>
                </>
              )}
              {isAdmin() && (
                <button
                  onClick={() => setShowIndustryDialog(true)}
                  className="bg-[#00244D] text-white px-4 py-2 rounded-lg shadow-lg hover:bg-[#00244D] focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 w-full sm:w-auto text-sm"
                  title="Add Industry"
                >
                  Add Industry
                </button>
              )}
            </div>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 sm:gap-6 mt-6 pb-12">
            {isLoadingIndustries ? (
              <div className="col-span-full flex items-center justify-center py-16">
                <Loader label="Loading industries..." size={56} className="flex-col gap-5 text-[#003DA5]" />
              </div>
            ) : filteredIndustries.length > 0 ? (
              filteredIndustries.map((industry, index) => (
                <IndustryCard key={`${industry.id}-${index}`} industry={industry} />
              ))
            ) : (
              <p className="text-center text-gray-600 col-span-full text-sm sm:text-base">No industries found.</p>
            )}
          </div>
        </div>
      </section>
      <IndustryDialog
        showModal={showIndustryDialog}
        setShowModal={setShowIndustryDialog}
        onCreateIndustry={createIndustry}
        locations={dropdownUniqueLocations}
      />
    </div>
  );
};

export default Industries;